import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable,Subscription } from 'rxjs';
import { Events} from 'ionic-angular';
import { first } from 'rxjs/operators';
import { User } from  '../../models/user';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { DataProvider } from '../data/data';
import { HttpClient } from '@angular/common/http';
import { firestore } from 'firebase';
import * as moment from 'moment';
import { LabelProvider } from '../../providers/label/label';
/*
  Generated class for the ActionPlanProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ActionPlanProvider {
  
  debugReport:any = [];
  constructor(private afs: AngularFirestore,private storage: Storage, public events:Events,private http: HttpClient, private dataProvider:DataProvider,private fbStorage: AngularFireStorage,public lp :LabelProvider) {
    console.log('Hello ActionPlanProvider Provider');
  }


  intializeSubscriptions(){

    this.events.subscribe('actionPlan:getActionPlans', () => {

         this.getActionPlans();

      });

    this.events.subscribe('actionPlan:getActionPlanDetails', (auditId:string) => {

         this.getActionPlanDetails(auditId);

      });

  	this.events.subscribe('actionPlan:getActionIssues', (auditId:string) => {

         this.getActionIssues(auditId);

      });

   this.events.subscribe('actionPlan:updateActionIssueDate', (auditId:string,issueId:string,dueDate:Date) => {

         this.updateActionIssueDate(auditId,issueId,dueDate);

      });

   this.events.subscribe('actionPlan:getTimeline', (auditId:string,issueId:string) => {

         this.getTimeline(auditId,issueId);

    });

   this.events.subscribe('actionPlan:updateStatus', (planId:string) => {

         this.updateStatus(planId);

      });

   this.events.subscribe('actionPlan:complete', (planId:string) => {

         this.completeActionPlan(planId);

      });

    this.events.subscribe('actionPlan:uploadIssueImage', (imgDtls) => {

        this.uploadActionPlanImage(imgDtls);

     });

    this.events.subscribe('actionPlan:deleteIssueImage', (imgDtls) => {

        this.deleteIssueImage(imgDtls);

     });

    this.events.subscribe('actionPlan:getIssueImages', (tmlDtls) => {

        this.getIssueImages(tmlDtls);

     });

     this.events.subscribe('actionPlan:saveIssueComment', (commentDtls) => {

        this.saveIssueComment(commentDtls);

     });

     this.events.subscribe('actionPlan:acceptRejectIssue', (issueDtls) => {

        this.acceptRejectIssue(issueDtls);

     });

  }

  removeSubscriptions(){
    this.events.unsubscribe('actionPlan:getActionPlans');
  	this.events.unsubscribe('actionPlan:getActionIssues');
    this.events.unsubscribe('actionPlan:updateActionIssueDate');
    this.events.unsubscribe('actionPlan:getTimeline');
    this.events.unsubscribe('actionPlan:getActionPlanDetails');
    this.events.unsubscribe('actionPlan:updateStatus');
    this.events.unsubscribe('actionPlan:uploadIssueImage');
    this.events.unsubscribe('actionPlan:deleteIssueImage');
    this.events.unsubscribe('actionPlan:saveIssueComment');
    this.events.unsubscribe('actionPlan:acceptRejectIssue');
    this.events.unsubscribe('actionPlan:getIssueImages');
  }

  getFormattedDate(date){
    return moment(date).format('DD-MM-YYYY');
  }

  async getActionPlans(){
    const actionPlans = await this.afs.collection('actionPlan').snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                      const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                  
                    return { id, ...data };
    }))).pipe(first()).toPromise();
     
    this.events.publish('actionPlan:actionPlanList',actionPlans);
  }

  async getActionPlanDetails(auditId){
     const plan = await this.afs.collection('actionPlan').doc(auditId).valueChanges().pipe(first()).toPromise();
     this.events.publish('actionPlan:actionPlanDetails',plan);
  }

  async getActionIssues(auditId){
   

  	 const actionIssues = await this.afs.collection('actionPlan').doc(auditId).collection('issues',ref => ref.orderBy('creationDate','desc')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                      const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                   
                    if(data.creationDate){
                      data.creationDate = data.creationDate.toDate();
                    }
                    return { id, ...data };
    }))).pipe(first()).toPromise();
     console.log(actionIssues);
    this.events.publish('actionPlan:actionIssues',actionIssues,auditId);
  }


  async updateActionIssueDate(auditId,issueId,dueDate){
      await this.afs.collection('actionPlan').doc(auditId).collection('issues').doc(issueId).update({dueDate:dueDate});
      await this.afs.collection('actionPlan').doc(auditId).collection('issues').doc(issueId).collection('timeline').add({
                    type:"info",
                    message:this.lp.labels['DUE_DATE_MSG']+" "+this.getFormattedDate(dueDate),
                    key:'due_date_set',
                    active:true,
                    creationDate:new Date()
      });
      this.events.publish('actionPlan:actionIssueUpdated');
  }

  async getTimeline(auditId,issueId){
     const timeline = await this.afs.collection('actionPlan').doc(auditId).collection('issues').doc(issueId).collection('timeline',ref => ref.where('active', '==', true).orderBy('creationDate','desc')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                      const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                   
                    if(data.creationDate){
                      data.creationDate = data.creationDate.toDate();
                    }
                    return { id, ...data };
    }))).pipe(first()).toPromise();
     console.log(timeline);
    this.events.publish('actionPlan:timeline',timeline);
  }

  async updateStatus(planId){
    await this.afs.collection('actionPlan').doc(planId).update({status:'verified'});
  }

  async completeActionPlan(planId){

     const actionIssues = await this.afs.collection('actionPlan').doc(planId).collection('issues',ref => ref.orderBy('creationDate','desc')).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                      const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                   
                    if(data.creationDate){
                      data.creationDate = data.creationDate.toDate();
                    }
                    return { id, ...data };
    }))).pipe(first()).toPromise();

     actionIssues.forEach(async(issue) => {

        await this.afs.collection('actionPlan').doc(planId).collection('issues').doc(issue.id).collection('timeline').add({
                    type:"comment",
                    message:'',
                    images:[],
                    key:'comment',
                    readOnly:false,
                    active:true,
                    creationDate:new Date()
        });

     });
    
      
  }

  async uploadActionPlanImage(imgDtls){
     const imgDoc = await this.afs.collection('actionPlan').doc(imgDtls.auditId).collection('issues').doc(imgDtls.issueId).collection('timeline').doc(imgDtls.timelineId).collection('images').add({uploadedAt:new Date()});
                 if(imgDoc && imgDoc.id){
                   const path = 'actionPlan/'+imgDtls.auditId+'issues/'+imgDtls.issueId+'timeline/'+imgDtls.timelineId+'/images/'+imgDoc.id+'.png';
                   const imgRef = this.fbStorage.ref(path);

                   await imgRef.putString(imgDtls.image,'data_url');

                   const downloadURL = await imgRef.getDownloadURL().pipe(first()).toPromise();

                   await this.afs.collection('actionPlan').doc(imgDtls.auditId).collection('issues').doc(imgDtls.issueId).collection('timeline').doc(imgDtls.timelineId).collection('images').doc(imgDoc.id).update({url:downloadURL,uploadedAt:new Date()});
                  
                   this.events.publish('actionPlan:issueImage',{id:imgDoc.id,url:downloadURL,timelineId:imgDtls.timelineId,timelineIndex:imgDtls.timelineIndex,index:imgDtls.index});

                 }

  }

  async deleteIssueImage(imgDtls){
     const path = 'actionPlan/'+imgDtls.auditId+'issues/'+imgDtls.issueId+'timeline/'+imgDtls.timelineId+'/images/'+imgDtls.imageId+'.png';
     const imgRef = this.fbStorage.ref(path);
     await imgRef.delete();
     await this.afs.collection('actionPlan').doc(imgDtls.auditId).collection('issues').doc(imgDtls.issueId).collection('timeline').doc(imgDtls.timelineId).collection('images').doc(imgDtls.imageId).delete();
  }

   async getIssueImages(tmlDtls){
    const timelineImgs = await this.afs.collection('actionPlan').doc(tmlDtls.auditId).collection('issues').doc(tmlDtls.issueId).collection('timeline').doc(tmlDtls.timelineId).collection('images').snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                     return { id, ...data };
    }))).pipe(first()).toPromise();
     console.log(timelineImgs);
    this.events.publish('actionPlan:issueImages',tmlDtls.index,timelineImgs);
  }


  async saveIssueComment(commDtls){

    console.log("saving comment");
    console.log(commDtls);


      await this.afs.collection('actionPlan').doc(commDtls.auditId).collection('issues').doc(commDtls.issueId).collection('timeline').doc(commDtls.timelineId).update({
        message:commDtls.comment,
        readOnly:true,
        user:{
          id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : '',
          name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : ''
        }, 
        creationDate:new Date()});

      // console.log("add tieline event");
      // if(commDtls.key == 'comment'){
      //   await this.afs.collection('actionPlan').doc(commDtls.auditId).collection('issues').doc(commDtls.issueId).collection('timeline').add({
                      
      //                  type:"review_comment",
      //                  message:"Review comments and accept or reject this issue",
      //                  key:'review_comment',
      //                  active:true,
      //                  creationDate:new Date()
      //     });

      //   console.log("timeline event added");
      // }
      // else if(commDtls.key == 'comment'){

        console.log("Adding another comment box******");
        await this.afs.collection('actionPlan').doc(commDtls.auditId).collection('issues').doc(commDtls.issueId).collection('timeline').add({
                    type:"comment",
                    message:'',
                    images:[],
                    key:'comment',
                    readOnly:false,
                    active:true,
                    creationDate:new Date()
        });
     // }
      this.events.publish('actionPlan:issueCommentSaved');
      this.events.publish('actionPlan:getTimeline',commDtls.auditId, commDtls.issueId);
  }


  async hideTimelineEvent(auditId,issueId,key){
    let timelineDocs =  await this.afs.collection('actionPlan').doc(auditId).collection('issues').doc(issueId).collection('timeline', ref => ref.where('key', '==', key)).snapshotChanges().pipe(
                  map(actions => actions.map(a => {
                    const data = a.payload.doc.data() as any;
                    const id = a.payload.doc.id;
                    if(data.creationDate){
                      data.creationDate = data.creationDate.toDate();
                    }
                    return { id, ...data };
     }))).pipe(first()).toPromise();

    if(timelineDocs){
        timelineDocs.forEach(async(doc) => {
          if(doc.key == key){
            await this.afs.collection('actionPlan').doc(auditId).collection('issues').doc(issueId).collection('timeline').doc(doc.id).update({active:false});
          }
        });
     }
  }

  async acceptRejectIssue(issueDtls){
      if(issueDtls.status == 'accept'){
        let timelineDocs =  await this.afs.collection('actionPlan').doc(issueDtls.auditId).collection('issues').doc(issueDtls.issueId).collection('timeline', ref => ref.orderBy('creationDate','desc').limit(1)).snapshotChanges().pipe(
                    map(actions => actions.map(a => {
                      const data = a.payload.doc.data() as any;
                      const id = a.payload.doc.id;
                      if(data.creationDate){
                        data.creationDate = data.creationDate.toDate();
                      }
                      return { id, ...data };
       }))).pipe(first()).toPromise();

      if(timelineDocs){
          timelineDocs.forEach(async(doc) => {
              await this.afs.collection('actionPlan').doc(issueDtls.auditId).collection('issues').doc(issueDtls.issueId).collection('timeline').doc(doc.id).delete();
            
          });
      }
      await this.afs.collection('actionPlan').doc(issueDtls.auditId).collection('issues').doc(issueDtls.issueId).update({status:'completed'});
      await this.afs.collection('actionPlan').doc(issueDtls.auditId).collection('issues').doc(issueDtls.issueId).collection('timeline').add({
                    type:"info",
                    message:this.lp.labels['ACTION_ISSUE_COMPLED_MSG'],
                    user:{
                       id:this.dataProvider.user && this.dataProvider.user.uid ? this.dataProvider.user.uid : '',
                       name:this.dataProvider.user && this.dataProvider.user.name ? this.dataProvider.user.name : ''
                    },
                    key:'issue_completed',
                    active:true,
                    creationDate:new Date()
      });
      this.hideTimelineEvent(issueDtls.auditId,issueDtls.issueId,'review_comment');
      this.events.publish('actionPlan:getTimeline',issueDtls.auditId, issueDtls.issueId);
    }
    else if(issueDtls.status == 'reject'){
      await this.afs.collection('actionPlan').doc(issueDtls.auditId).collection('issues').doc(issueDtls.issueId).collection('timeline').add({
                    type:"info",
                    message:this.lp.labels['ACTION_ISSUE_REJECTED_MSG'],
                    key:'issue_rejected',
                    active:true,
                    creationDate:new Date()
      });
      await this.afs.collection('actionPlan').doc(issueDtls.auditId).collection('issues').doc(issueDtls.issueId).collection('timeline').add({
                    type:"comment",
                    message:'',
                    images:[],
                    key:'comment',
                    readOnly:false,
                    active:true,
                    creationDate:new Date()
      });
      this.hideTimelineEvent(issueDtls.auditId,issueDtls.issueId,'review_comment');
      this.events.publish('actionPlan:getTimeline',issueDtls.auditId, issueDtls.issueId);
    }
  }


  async actionReportData(auditId) {

    this.debugReport = [];
    console.log('auditId', auditId);
    let report = {};
    let sections = [];
    let typeQuestions = {};
    let secQuestions = {};
    let answeredModule = [];
    let completedReport = [];
    let sortedReport = [];
    let audit;
    let userDetails;
    let reportData  = {};

    try {
        const auditDoc = await this.afs.collection('audits').doc(auditId).get().toPromise();
        audit = auditDoc.data();
        console.log(audit);

        const userDoc = await this.afs.collection('users').doc(audit.auditor.uid).get().toPromise();
        userDetails = userDoc.data();

        const sectionDocs = await this.afs.collection('audits').doc(auditId)
            .collection('sections', ref => ref.orderBy('order')).get().toPromise();

        sectionDocs.forEach(section => {
            if (section && section.id && section.data()) {
                report[section.id] = {
                    details: section
                };
                sections.push({ id: section.id, ...section.data() });
            }
        });

        await Promise.all(sections.map(async (section, index) => {
            typeQuestions[section.id] = {};
            secQuestions[section.id] = {};
            let tyQuestions = [];
            let orderList = {};
          const tyQuestionDocs = await this.afs.collection('audtypes').doc(audit.type.id)
            .collection('sections').doc(section.id).collection('questions', ref => ref.orderBy('order')).get().toPromise();

            tyQuestionDocs.forEach(question => {
                if (question && question.id && question.data()) {
                    tyQuestions.push({ id: question.id, ...question.data() });
                    orderList[question.id] = question.data().order;
                }
            });

            typeQuestions[section.id] = tyQuestions;
            console.log("orderList:",orderList);
            const questionDocs = await this.afs.collection('audits').doc(auditId)
                .collection('sections').doc(section.id).collection('questions').get().toPromise();

                console.log(auditId);
                console.log("section Id:",section.id);
            questionDocs.forEach(question => {
                if (question && question.id && question.data()) {
                    secQuestions[section.id][question.id] = question.data();

                    if (question.data().answeredQuestion) {
                        let answerData = question.data().answeredQuestion;
                        answerData['section'] = section.name;

                        console.log(section.name);
                        console.log("question.id",question.id);
                        let queOrder = parseInt(orderList[question.id]) < 10 ? '0'+orderList[question.id].toString() : orderList[question.id].toString();
                        answerData['order'] = parseFloat(section.order.toString() +'.'+queOrder);
                        answeredModule.push(answerData);
                    }
                }
            });
        }));

        let totalScore:number = 0;
        let totalPossibleScore:number = 0;

        reportData['scoring'] = [];

        for(var a=0; a<answeredModule.length;a++){


          let answered = answeredModule[a];
          

            let queScore = 0;
            console.log("answered:",answered);

            if(answered.scoreForAccreditation && !answered.humanScoring){
             

              console.log(answered.optChecked);
              if (answered.questionType === 'single' && typeof answered.optChecked !== 'undefined') {

                  let selectedOptionIndex = answered.options.findIndex(option => option.text === answered.optChecked);
                  console.log("selectedOptionIndex:",selectedOptionIndex + " "+ answered.optChecked);
                  if(selectedOptionIndex >= 0){
                        if(!answered['scoring'][selectedOptionIndex]['score']){
                          answered['scoring'][selectedOptionIndex]['score'] = 0;
                        }
                        if(!answered['scoring'][selectedOptionIndex]['multiplierValue']){
                          answered['scoring'][selectedOptionIndex]['multiplierValue'] = 0;
                        }

                        this.saveDebugData(answered, selectedOptionIndex);

                        answeredModule[a]['score'] = answered['scoring'][selectedOptionIndex]['score'];
                        answeredModule[a]['weighting'] = answered['scoring'][selectedOptionIndex]['weighting'];

                      if(!answered.showMultiplier){

                          totalScore = totalScore + answered['scoring'][selectedOptionIndex]['score'];
                          totalPossibleScore = totalPossibleScore + answered['scoring'][selectedOptionIndex]['weighting'];
                      }
                      else{
                         totalScore = totalScore  + answered['scoring'][selectedOptionIndex]['score']*answered['scoring'][selectedOptionIndex]['multiplierValue'];
                         totalPossibleScore = totalPossibleScore + answered['scoring'][selectedOptionIndex]['weighting']**answered['scoring'][selectedOptionIndex]['multiplierValue'];
                      }

                      console.log("totalScore:",totalScore);
                      console.log("totalPossibleScore:",totalPossibleScore);
                }

              }
              else  if (answered.questionType === 'multiple') {

                
                  answered.options.forEach((option, index) => {
                    console.log(option);
                    if (option.isChecked) {

                          console.log("ischecked is true");

                          if(!answered['scoring'][index]['score']){
                            answered['scoring'][index]['score'] = 0;
                          }
                          if(!answered['scoring'][index]['multiplierValue']){
                          answered['scoring'][index]['multiplierValue'] = 0;
                          }

                          this.saveDebugData(answered, index);
                           
                                
                          if(!answered.showMultiplier){
                              totalScore = totalScore + answered['scoring'][index]['score'];
                              totalPossibleScore = totalPossibleScore + answered['scoring'][index]['weighting'];
                          }
                          else{
                             totalScore = totalScore  + answered['scoring'][index]['score']*answered['scoring'][index]['multiplierValue'];
                             totalPossibleScore = totalPossibleScore + answered['scoring'][index]['weighting']**answered['scoring'][index]['multiplierValue'];
                          }


                           console.log("totalScore:",totalScore);
                           console.log("totalPossibleScore:",totalPossibleScore);
                    }
                   });

                     

              }
              else if (answered.questionType === 'essay' && answered.essayText) {


                      answeredModule[a]['score'] = answered['scoring'][0]['score'];
                      answeredModule[a]['weighting'] = answered['scoring'][0]['weighting'];

                       this.saveDebugData(answered, 0);

                     if(!answered.showMultiplier){
                      totalScore = totalScore + answered['scoring'][0]['score'];
                      totalPossibleScore = totalPossibleScore + answered['scoring'][0]['weighting'];
                      }
                      else{
                         totalScore = totalScore  + answered['scoring'][0]['score']*answered['scoring'][0]['multiplierValue'];
                         totalPossibleScore = totalPossibleScore + answered['scoring'][0]['weighting']**answered['scoring'][0]['multiplierValue'];
                      }

                     console.log("totalScore:",totalScore);
                     console.log("totalPossibleScore:",totalPossibleScore);

              }


            }
            else{
                   if (answered.questionType === 'single' && typeof answered.optChecked !== 'undefined') {

                        let selectedOptionIndex = answered.options.findIndex(option => option.text === answered.optChecked);
                         if(selectedOptionIndex >= 0){
                           this.saveDebugData(answered, selectedOptionIndex);
                         }
                    }
                     else  if (answered.questionType === 'multiple') {

                
                        answered.options.forEach((option, index) => {
                          console.log(option);
                          if (option.isChecked) {
                             this.saveDebugData(answered, index);

                          }
                      });
                    }
                     else if (answered.questionType === 'essay' && answered.essayText) {

                       this.saveDebugData(answered, 0);

                     }
            }



            let content = {
                scoring: [],
                auditReportContent: [],
                actionPlanContent: []
            };

            let sortType = '';

            if (userDetails.reason === 'To save money') {
                  sortType =  'greenhouse';
            } else if (userDetails.reason === 'To reduce carbon emissions & waste') {
                   sortType = 'reduceCost';
            } else if (userDetails.reason === 'To find simple & low cost actions') {
                  sortType = 'implementation';
            }

          

            if (answered.questionType === 'single') {
                let selectedOptionIndex = answered.options.findIndex(option => option.text === answered.optChecked);
                if (selectedOptionIndex !== -1) {
                    content.scoring.push(answered.scoring[selectedOptionIndex]);
                    content.auditReportContent.push(answered.auditReportContent[selectedOptionIndex]);
                    content.actionPlanContent.push(answered.actionPlanContent[selectedOptionIndex]);

                      if(answered.auditReportContent[selectedOptionIndex]['actionHeadline'] && answered.auditReportContent[selectedOptionIndex]['actionDetails']){
                        completedReport.push({
                            question: answered.text,
                            questionType: answered.questionType,
                            content: content,
                            score:answered.score ? answered.score : 0,
                            selectedOption:answered.optChecked,
                            sortValue:answered.scoring[selectedOptionIndex][sortType]
                        });
                      }

                    
                }
            } else if (answered.questionType === 'multiple') {
                answered.options.forEach((option, index) => {
                    if (option.isChecked) {
                        content.scoring.push(answered.scoring[index]);
                        content.auditReportContent.push(answered.auditReportContent[index]);
                        content.actionPlanContent.push(answered.actionPlanContent[index]);

                        if(answered.auditReportContent[index]['actionHeadline'] && answered.auditReportContent[index]['actionDetails']){
                           completedReport.push({
                            question: answered.text,
                            questionType: answered.questionType,
                            content: content,
                            score:answered.score ? answered.score : 0,
                            selectedOption:option.text,
                            sortValue:answered.scoring[index][sortType]
                          });
                        }
                        
                    }
                });
            }
        };
       
        completedReport = completedReport.sort((a, b) => b.sortValue - a.sortValue);

        sortedReport = completedReport.sort((a, b) => b.sortValue - a.sortValue);

        reportData['sorting'] = completedReport;

        sortedReport = sortedReport.slice(0,10);

        console.log("completedReport",completedReport);
        console.log('Sorted Report:', sortedReport);

        console.log("Audit details for Sorting & Score");

        console.log("totalScore:",totalScore);
        console.log("totalPossibleScore:",totalPossibleScore);

        let gobtScore = Math.ceil(totalScore*100 / totalPossibleScore);

        console.log("gobtScore",gobtScore);

        await this.afs.collection('audits').doc(auditId).update({gobtScore:gobtScore});

         console.log("Debug Report:",this.debugReport);


        this.debugReport = this.debugReport.sort((a, b) => a.order - b.order);

        await this.afs.collection('audits').doc(auditId).collection('debug').doc('debugReport').set({report:this.debugReport});

        console.log(report);
        console.log(sections);
        console.log(typeQuestions);
        console.log(secQuestions);
        console.log("*********************************answeredModule*************************************");
        console.log(answeredModule);
        
        console.log(completedReport);
        console.log(audit);
        console.log(userDetails);


       
       

        return sortedReport;
    } catch (error) {
        console.error("Error in actionReportData:", error);
        throw error;
    }
}
  
async saveDebugData(answer, index){
    let debugRow = {
        section : answer.section ? answer.section : '',
        question : answer.text ? answer.text : '',
        questionType: answer.questionType ? answer.questionType : '',
        scoreForAccreditation:answer.scoreForAccreditation ? answer.scoreForAccreditation : false,
        humanScoring:answer.humanScoring ? answer.humanScoring : false,
        showLogic:answer.showLogic ? answer.showLogic : false,
        mandatory:answer.mandatory ? answer.mandatory : false,
        isMultiplier:answer.showMultiplier ? answer.showMultiplier : false,
        answer:answer.options[index]['text'] ? answer.options[index]['text'] : '',
        score:answer.scoring[index]['score'] ? answer.scoring[index]['score'] : 0,
        weighting:answer.scoring[index]['weighting'] ? answer.scoring[index]['weighting'] : 0,
        greenhouse:answer.scoring[index]['greenhouse'] ? answer.scoring[index]['greenhouse'] : 0,
        implementation:answer.scoring[index]['implementation'] ? answer.scoring[index]['implementation'] : 0,
        reduceCost:answer.scoring[index]['reduceCost'] ? answer.scoring[index]['reduceCost'] : 0,
        multiplierValue:answer.scoring[index]['multiplierValue'] ? answer.scoring[index]['multiplierValue'] : 0,
        actionHeadline:answer.auditReportContent[index]['actionHeadline'] ? answer.auditReportContent[index]['actionHeadline'] : '',
        actionDetails:answer.auditReportContent[index]['actionDetails'] ? answer.auditReportContent[index]['actionDetails'] : '',
        resourceList:answer.auditReportContent[index]['resourceList'] ? answer.auditReportContent[index]['resourceList'] : '',
        summaryReport:answer.auditReportContent[index]['summaryReport'] ? answer.auditReportContent[index]['summaryReport'] : '',
        Darebin:answer.actionPlanContent[index]['Darebin'] ? answer.actionPlanContent[index]['Darebin'] : '',
        DefaultText:answer.actionPlanContent[index]['Default Text'] ? answer.actionPlanContent[index]['Default Text'] : '',
        Hume:answer.actionPlanContent[index]['Hume'] ? answer.actionPlanContent[index]['Hume'] : '',
        MerriBek:answer.actionPlanContent[index]['Merri-Bek'] ? answer.actionPlanContent[index]['Merri-Bek'] : '',
        Yarra:answer.actionPlanContent[index]['Yarra'] ? answer.actionPlanContent[index]['Yarra'] : '',
        order:answer.order
    }

    this.debugReport.push(debugRow);
}

async checkAndCreateActionPlanCollection(auditId, data) {

  console.log('auditId ---- action plan provider', auditId)
  try {
      // Check if the collection exists
      const collectionRef = this.afs.collection('audits').doc(auditId).collection('actionPlan');
      const collectionSnapshot = await collectionRef.get().toPromise();

      // If the collection doesn't exist, create it
      if (collectionSnapshot.empty) {

          let idCount = 1;
          for(let i = 0; i < data.length; i++){
            for(let j = 0; j < data[i].content.auditReportContent.length; j++){
              
               
                data[i].content.auditReportContent[j].idCount = idCount;
                if(idCount > 3){
                 data[i].content.auditReportContent[j].status = false;
                }
                else{
                 data[i].content.auditReportContent[j].status = true;
                }
                idCount++;
              
             
            }
              
          }
          console.log("action data:",data);
          await collectionRef.add({actionDetails: data}); // Add a dummy document to create the collection
          console.log(`Collection created successfully.`);
         // this.checkAndCreateActionPlanCollection(auditId, data);
      }
        console.log('collection existing');

        const actionDetails = await collectionRef.snapshotChanges().pipe(
          map(actions => actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          }))).pipe(first()).toPromise();


          return actionDetails;
      
  } catch (error) {
      console.error(`Error checking/creating collection':`, error);
      throw error;
  }
}


  async updateActionPlanCollection(auditId, data) {
    console.log('auditId ---- action plan provider', auditId)
    console.log('data--------', data)
    try {
      await this.afs.collection('audits').doc(auditId).collection('actionPlan').doc(data[0].id).update({ actionDetails: data[0].actionDetails, actionPlanSelected: true });
      await this.afs.collection('audits').doc(auditId).update({ actionPlanSelected: true });
      console.log(`Collection updated successfully.`);

      return true;
    } catch (error) {
      return false;
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/action-plan/action-plan.ts